/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Allow_ErrorsInputs */

const cs_import_allow_errors = /** @type {(inputs: Import_Allow_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Povolit commit i při chybách řádků`)
};

const en_import_allow_errors = /** @type {(inputs: Import_Allow_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow commit even with row errors`)
};

/**
* | output |
* | --- |
* | "Allow commit even with row errors" |
*
* @param {Import_Allow_ErrorsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_allow_errors = /** @type {((inputs?: Import_Allow_ErrorsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Allow_ErrorsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_allow_errors(inputs)
	return cs_import_allow_errors(inputs)
});